<!-- @format -->

<ng-container *transloco="let t">
  <div class="modal-header">
    <fudis-heading [level]="2">
      @if (resultCode === 'EMREX_OK') { {{ t('PLAN.EMREX_RESULT_MODAL.SUCCESS_TITLE') }} } @else { {{
      t('PLAN.EMREX_RESULT_MODAL.FAILURE_TITLE') }} }
    </fudis-heading>
    <sis-modal-close-button />
  </div>

  <div class="modal-body">
    @if (resultCode === 'EMREX_OK') {
    <p>{{ t('PLAN.EMREX_RESULT_MODAL.SUCCESS_GUIDANCE_1') }}</p>
    <p>{{ t('PLAN.EMREX_RESULT_MODAL.SUCCESS_GUIDANCE_2') }}</p>
    } @else { @if (resultCode.startsWith('SISU')) {
    <p>{{ t('PLAN.EMREX_RESULT_MODAL.SISU_FAILURE_GUIDANCE') }}</p>
    <p>{{ t('PLAN.EMREX_RESULT_MODAL.FAILURE_GUIDANCE_2') }}</p>
    } @if (resultCode === 'SISU_SESSION_INVALID') {
    <p>{{ t('PLAN.EMREX_RESULT_MODAL.SESSION_INVALID_GUIDANCE_1') }}</p>
    <p>{{ t('PLAN.EMREX_RESULT_MODAL.SESSION_INVALID_GUIDANCE_2') }}</p>
    } @if (['EMREX_ERROR', 'EMREX_NO_RESULTS', 'EMREX_CANCEL'].includes(resultCode)) {
    <p>{{ t('PLAN.EMREX_RESULT_MODAL.FAILURE_GUIDANCE_1') }}</p>
    <p>{{ t('PLAN.EMREX_RESULT_MODAL.FAILURE_GUIDANCE_2') }}</p>
    } @if (resultCode === 'EMREX_PAYLOAD_TOO_LARGE') {
    <p>{{ t('PLAN.EMREX_RESULT_MODAL.PAYLOAD_FAILURE_GUIDANCE_1') }}</p>
    <p>{{ t('PLAN.EMREX_RESULT_MODAL.PAYLOAD_FAILURE_GUIDANCE_2') }}</p>
    } @if (resultCode === 'EMREX_PERSON_MISMATCH') {
    <p>{{ t('PLAN.EMREX_RESULT_MODAL.PERSON_MISMATCH_GUIDANCE_1') }}</p>
    <p>{{ t('PLAN.EMREX_RESULT_MODAL.PERSON_MISMATCH_GUIDANCE_2') }}</p>
    }
    <p>{{ t('PLAN.EMREX_RESULT_MODAL.ERROR_CODE') }}: {{ resultCode }}</p>
    }
  </div>

  <div class="modal-footer confirm-dialog-footer">
    <sis-button (clicked)="modal.dismiss()">{{ t('CLOSE') }}</sis-button>
  </div>
</ng-container>
